import createModel from './lib/create_model';

const TaskReopenedContent = createModel({
  modelName: 'TaskReopenedContent',
  properties: {
    note: String,
    taskItemId: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default TaskReopenedContent;
